import { render, staticRenderFns } from "./Exams.vue?vue&type=template&id=5959374b&lang=pug&"
import script from "./Exams.vue?vue&type=script&lang=js&"
export * from "./Exams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports